import { render, staticRenderFns } from "./Depletion.vue?vue&type=template&id=cd85a18c&"
import script from "./Depletion.vue?vue&type=script&lang=js&"
export * from "./Depletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports